import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import "./Header.css";

const links = [
  { name: "page.gallery", link: "/gallery" },
  // {name: "page.projects", link: "/projects"},
  { name: "page.equipment", link: "/equipment" },
  // { name: "page.tips", link: "/tips" },
  { name: "page.about", link: "/about" },
];

export default function Header({ transparent = false }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <header
        className={`header${transparent && !open ? " transparent" : ""}${open ? " open" : ""}`}
      >
        <div className="bar">
          <div className="bar-item">
            <Link className="logo" to="/">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95.5 21.601">
                <path d="M8.74 10.737H2.634v6.427H0V1.997h9.635v2.125h-7v4.51H8.74zM14.167 17.164h-2.531V.945h2.531zM16.448 11.424q0-1.656.656-2.98.656-1.332 1.844-2.04 1.187-.72 2.73-.72 2.28 0 3.697 1.47 1.427 1.468 1.542 3.895l.01.594q0 1.666-.646 2.979-.635 1.312-1.833 2.031-1.187.719-2.75.719-2.385 0-3.823-1.584-1.427-1.593-1.427-4.24zm2.531.219q0 1.74.719 2.729.719.98 2 .98t1.99-1q.718-1 .718-2.928 0-1.708-.74-2.708-.728-1-1.989-1-1.24 0-1.969.99-.729.978-.729 2.937zM35.375 11.424q0-1.656.656-2.98.657-1.332 1.844-2.04 1.187-.72 2.729-.72 2.281 0 3.698 1.47 1.427 1.468 1.542 3.895l.01.594q0 1.666-.646 2.979-.635 1.312-1.833 2.031-1.188.719-2.75.719-2.385 0-3.823-1.584-1.427-1.593-1.427-4.24zm2.531.219q0 1.74.719 2.729.719.98 2 .98t1.99-1q.718-1 .718-2.928 0-1.708-.74-2.708-.728-1-1.989-1-1.24 0-1.969.99-.729.978-.729 2.937zM47.552 11.445c0-1.75.41-3.146 1.23-4.188.825-1.048 1.92-1.572 3.28-1.572 1.285 0 2.295.448 3.032 1.343l.114-1.135h2.281V16.82c0 1.48-.462 2.646-1.385 3.5-.917.854-2.156 1.281-3.719 1.281h-3.583v-2h3.437c.84 0 1.504-.23 1.99-.687.486-.452.73-1.118.73-2v-.76c-.73.812-1.702 1.218-2.917 1.218-1.32 0-2.4-.524-3.24-1.573-.833-1.049-1.25-2.5-1.25-4.354zm2.52.219c0 1.132.23 2.024.688 2.677.465.646 1.108.969 1.927.969 1.021 0 1.778-.438 2.271-1.313V9.04c-.48-.854-1.23-1.281-2.25-1.281-.833 0-1.482.33-1.948.99-.458.659-.687 1.631-.687 2.916zM65.989 8.206q-.5-.084-1.031-.084-1.74 0-2.344 1.334v7.708h-2.531V5.893H62.5l.062 1.26q.917-1.468 2.542-1.468.541 0 .896.145zM74.01 17.164q-.167-.323-.292-1.052-1.208 1.26-2.958 1.26-1.698 0-2.77-.968t-1.074-2.396q0-1.802 1.334-2.76 1.343-.97 3.833-.97h1.552V9.54q0-.875-.49-1.396-.49-.531-1.49-.531-.864 0-1.416.437-.552.428-.552 1.094h-2.531q0-.927.614-1.729.615-.813 1.667-1.27 1.063-.46 2.365-.46 1.979 0 3.156 1 1.177.99 1.208 2.792v5.084q0 1.52.427 2.427v.177zm-2.781-1.823q.75 0 1.406-.364.667-.365 1-.98v-2.125H72.27q-1.406 0-2.114.49-.709.49-.709 1.385 0 .73.48 1.167.49.427 1.302.427zM79.708 17.164V7.768h-1.719V5.893h1.719V4.862q0-1.875 1.042-2.896Q81.79.946 83.666.946q.667 0 1.417.187l-.062 1.98q-.417-.084-.97-.084-1.812 0-1.812 1.864v1h2.292v1.875h-2.292v9.396zM90.427 9.601l2.146-3.708h2.812l-3.448 5.552 3.563 5.719h-2.792l-2.25-3.854L85.64 21.6h-2.997l6.327-10.156-3.438-5.552h2.792zM33.53.567h6.047v3.78H33.53zM39.956 0h1.89v4.913h-1.89zM27.105.945v3.023h1.701a2.457 2.457 0 012.266-1.512 2.457 2.457 0 012.08 1.149V.945zM25.215 1.323h1.512v2.268h-1.512zM22.569.945h2.268v3.024h-2.268z" />
                <path d="M31.074 2.835a2.079 2.079 0 00-2.08 2.078 2.079 2.079 0 00.379 1.196l-1.78 11.264h1.512L30.75 6.967a2.079 2.079 0 00.324.025 2.079 2.079 0 00.324-.025l1.64 10.406h1.514L32.775 6.109a2.079 2.079 0 00.377-1.196 2.079 2.079 0 00-2.078-2.078z" />
              </svg>
            </Link>
          </div>
          <div className="bar-item">
            {links.map((entry, index) => (
              <Link key={index} to={entry.link}>
                {t(entry.name)}
              </Link>
            ))}
            <div className="menu" onClick={() => setOpen(!open)}>
              <div className="menu-bar1"></div>
              <div className="menu-bar2"></div>
              <div className="menu-bar3"></div>
            </div>
          </div>
        </div>
        <nav className="navigation">
          {links.map((entry, index) => (
            <Link key={index} to={entry.link}>
              {t(entry.name)}
            </Link>
          ))}
        </nav>
      </header>
    </>
  );
}
